
import { Component, Vue, Prop} from 'vue-property-decorator';
import LegalDutyAnotherPersonFsSurvey from "./LegalDutyAnotherPersonFSSurvey.vue";
import PageBase from "../../PageBase.vue";

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");
import { stepInfoType, stepResultInfoType } from "@/types/Application";

@Component({
    components:{
        LegalDutyAnotherPersonFsSurvey,
        PageBase
    }
})
export default class LegalDutyAnotherPersonFS extends Vue {

    @Prop({required: true})
    step!: stepInfoType;        

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    currentStep =0;
    currentPage =0;
    showTable = true;

    legalDutyAnotherPersonFsExists = null;  

    anotherPersonExpenseData = [];
    anyRowToBeEdited = null;
    editId = null; 
    incompleteError =  false;
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
         Vue.nextTick(()=>{
            const el = document.getElementById('legal-duty-another-person-fs-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public childComponentData(value) {       
        this.showTable = value;
    }

    public populateSurveyData(anotherPersonValue) {

        const currentIndexValue = this.anotherPersonExpenseData?.length > 0 ? this.anotherPersonExpenseData[this.anotherPersonExpenseData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newChild = { ...anotherPersonValue, id };
        this.anotherPersonExpenseData = [...this.anotherPersonExpenseData, newChild];

        this.showTable = true; 
    }

    public deleteRow(rowToBeDeleted) {
       
        this.anotherPersonExpenseData = this.anotherPersonExpenseData.filter(data => {
            return data.id !== rowToBeDeleted;
        });
        this.surveyHasError();
    }

    public editRow(editedRow) {
        this.anotherPersonExpenseData = this.anotherPersonExpenseData.map(data => {
            return data.id === this.editId ? editedRow : data;
        });
        this.showTable = true;
        this.surveyHasError();
    }

    public onPrev() {
       Vue.prototype.$UpdateGotoPrevStepPage();
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();
    }

    created() {

        if (this.step.result?.legalDutyAnotherPersonFsExists) {
            this.legalDutyAnotherPersonFsExists = this.step.result.legalDutyAnotherPersonFsExists;
        }

        if (this.step.result?.legalDutyAnotherPersonFSSurvey?.data) {
            this.anotherPersonExpenseData = this.step.result.legalDutyAnotherPersonFSSurvey.data;
        }
             
    }

    mounted(){
        Vue.nextTick(()=>this.surveyHasError());
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
    }

    public surveyHasError(){
        let progress = this.anotherPersonExpenseData.length==0? 50 : 100;
        
        if(this.legalDutyAnotherPersonFsExists == 'No') progress =100;

        this.incompleteError =  false;        
        for(const anotherPersonExpense of this.anotherPersonExpenseData){
            if ((this.legalDutyAnotherPersonFsExists=='Yes') && 
                (!anotherPersonExpense.antherPersonFullName || !anotherPersonExpense.monthlyPayment || !anotherPersonExpense.yearlyPayment)){            
                this.incompleteError = true;  
                progress = 50;    
                break
            }
        }    

        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }

    public isDisableNext() {
        return (!this.legalDutyAnotherPersonFsExists || 
            (this.legalDutyAnotherPersonFsExists == 'Yes') 
            && this.anotherPersonExpenseData?.length <= 0 );
    }

    beforeDestroy() {
        this.surveyHasError();  
        
        let anotherPersonExpenseInfo = this.getAntherPersonExpenseResults()        
        
        if(this.legalDutyAnotherPersonFsExists == 'No')
            anotherPersonExpenseInfo = null
        
        this.UpdateStepResultData(
            {
                step:this.step, 
                data: {
                    legalDutyAnotherPersonFsExists: this.legalDutyAnotherPersonFsExists,
                    legalDutyAnotherPersonFSSurvey: anotherPersonExpenseInfo
                }
            }
        )       
    }

    public getAntherPersonExpenseResults(){
        const questionResults: {name:string; value: any; title:string; inputType:string}[] =[];
        for(const anotherPersonExpense of this.anotherPersonExpenseData)
        {
            questionResults.push({name:'legalDutyAnotherPersonFSSurvey', value: this.getAntherPersonExpenseInfo(anotherPersonExpense), title:'Another Person Expense '+anotherPersonExpense.id +' Information', inputType:''})
        }
        
        return {data: this.anotherPersonExpenseData, questions:questionResults, pageName:'Another Person Expense Information', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getAntherPersonExpenseInfo(anotherPersonExpense){
        const resultString = [];

        resultString.push(Vue.filter('styleTitle')("Name: ")+(anotherPersonExpense.antherPersonFullName));
        resultString.push(Vue.filter('styleTitle')("Monthly Payment: ")+(anotherPersonExpense.monthlyPayment));
        resultString.push(Vue.filter('styleTitle')("Yearly Payment: ")+(anotherPersonExpense.yearlyPayment));

        return resultString
    } 
    
}
